import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, {
        wrap: "",
        class: _normalizeClass(`card_${_ctx.cardColor} card`),
        style: {"height":"50px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_flex, {
            xs3: "",
            class: "d-flex flex-column align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "#FFF",
                size: "1.5em"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cardIcon), 1)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.cardValue) + _toDisplayString(_ctx.unit), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_flex, {
            xs9: "",
            style: {"color":"#fff"},
            class: "d-flex align-center pl-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.cardTitle), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}